import TemplateView from '../TemplateView'
import SimpleTooltip from '../SimpleTooltip'
import $ from 'jquery'
import {isEnter} from '../keyHandlers'
import DotsLoadingIndicator from './DotsLoadingIndicator'

const LOADING_DELAY = 250

export default class Button extends TemplateView {
    constructor({
        additionalClass = '',
        onClickCb = () => {},
        label = '',
        withPlusIcon = false,
        withDisableTooltip = false,
        disableTooltipText = '',
        tooltipAdditionalClass = false,
        tabindex = -1,
        handleEnterKeydown = false,
        withLoading = false,
    }) {
        super(null)

        this.params = {
            additionalClass,
            onClickCb,
            withDisableTooltip,
            tooltipAdditionalClass,
            tabindex,
            handleEnterKeydown,
            withLoading,
        }

        this.state = {
            label,
            disabled: false,
            disableTooltipText,
            withPlusIcon,
            loading: false,
        }

        this.onAnyStatePropertyChanged(['disabled', 'disableTooltipText'], ({disabled, disableTooltipText}) => {
            this.$el.toggleClass('disabled', disabled)
            if (this.params.withDisableTooltip) {
                this.tooltip.setText(disableTooltipText)
                this.tooltip.toggle(disabled)
            }
        })
        this.onStatePropertyChanged('label', label => this.$label.text(label))
        this.onStatePropertyChanged('withPlusIcon', withPlusIcon => this.getEl().toggleClass('withPlusIcon', withPlusIcon))
        this.onStatePropertyChanged('loading', loading => this._refreshLoading(loading))
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            label: this.state.label,
            tabindex: this.params.tabindex
        }
    }

    templateHtml() {
        return `<div class='components_button <%=additionalClass%>' tabindex=<%=tabindex%>>
                    <div class='components_button_label'>
                        <%-label%>
                    </div>
                    <div class='loadingIndicatorContainer'/>
               </div>`
    }

    afterRender() {
        this.$el.on('click', this._handleClick)

        if (this.params.withDisableTooltip) {
            this.tooltip = new SimpleTooltip({
                extraClass: this.params.tooltipAdditionalClass,
            }).init($('body'))
            this.tooltip.subscribeToMouseEvents(this.$el)
            this.tooltip.disable()
        }

        if (this.params.handleEnterKeydown) {
            this.$el.keydown(e => {
                if (isEnter(e.keyCode)) {
                    this.params.onClickCb()
                }
            })
        }

        this.$label = this.find('.components_button_label')
        if (this.params.withLoading) {
            new DotsLoadingIndicator().init(this.find('.loadingIndicatorContainer'))
        }

        this.renderInitialState()
    }

    focus() {
        this.$el.focus()
    }

    _handleClick = (e) => {
        e.stopPropagation()
        if (!this.state.disabled && !this.state.loading) {
            this.params.onClickCb(e)
        }
    }

    _refreshLoading(loading) {
        if (this.params.withLoading) {
            clearTimeout(this.loadingAnimationTimeout)
            this.loadingAnimationTimeout = setTimeout(() => this.getEl().toggleClass('loading', loading), loading ? LOADING_DELAY : 0)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/components/Button.js